import { BellIcon } from '@heroicons/react/24/outline';
import { addDays, isBefore, parseISO } from 'date-fns';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useAlertStore } from '@/common/stores/useAlertStore';

const NOTIFICATION_LAST_ASKED_KEY = 'notification_last_asked';

export const NotificationPermission = () => {
  const { t } = useTranslation();
  const { notificationsPermission, requestNotificationPermission } = useAlertStore();

  const shouldAskForPermission = () => {
    if (notificationsPermission !== 'default') return false;

    const lastAsked = localStorage.getItem(NOTIFICATION_LAST_ASKED_KEY);
    if (!lastAsked) return true;

    const lastAskedDate = parseISO(lastAsked);
    const nextAskDate = addDays(lastAskedDate, 1);
    return isBefore(nextAskDate, new Date());
  };

  const handlePermissionRequest = async () => {
    localStorage.setItem(NOTIFICATION_LAST_ASKED_KEY, new Date().toISOString());
    await requestNotificationPermission();
  };

  useEffect(() => {
    if (shouldAskForPermission()) {
      handlePermissionRequest();
    }
  }, [notificationsPermission]);

  if (notificationsPermission === 'default' && shouldAskForPermission()) {
    return (
      <button
        className="rounded-full hover:bg-gray-100 transition-all"
        title={t('notifications.enableTitle')}
        onClick={handlePermissionRequest}
      >
        <BellIcon className="h-5 w-5 text-gray-500 hover:text-gray-700" />
      </button>
    );
  }

  return null;
};
